import { IStorage } from "./IStorage.js";

export class IStorageSession extends IStorage
{
    override get(name: string, defaultValue: string)
    {
        return sessionStorage.getItem(name) ?? defaultValue;
    }
    override set(name: string, value: string)
    {
        sessionStorage.setItem(name, value);
    }
    override del(name: string)
    {
        sessionStorage.removeItem(name);
    }
}